import '/components/estate-favorite/estate-favorite';
import '/components/estate-favorite/estate-favorite.scss';
